import React, { memo } from 'react';
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import SaveIcon from "@mui/icons-material/Save";
import UpdateIcon from "@mui/icons-material/Update";
import { Button, Checkbox, FormControlLabel, Grid } from '@mui/material';


const StatusSubmitGrid = ({ status, handleChange, isEdit }) => {
    return (
        <>
            <Grid container justifyContent="flex-end" mt={2} spacing={1}>
                <Grid container item xs={12} md={6} justifyContent={'flex-start'}>
                    <FormControlLabel
                        name='status'
                        control={<Checkbox checked={Boolean(status)} />}
                        onChange={handleChange}
                        label="Status"
                    />
                </Grid>
                <Grid item xs={6} md={3}>
                    <Button
                        type='reset'
                        fullWidth
                        size="small"
                        color={'secondary'}
                        variant="contained"
                        title={"Reset"}
                        startIcon={<RotateLeftIcon />}
                    >
                        {"Reset"}
                    </Button>
                </Grid>
                <Grid item xs={6} md={3}>
                    <Button
                        type='submit'
                        fullWidth
                        size="small"
                        variant="contained"
                        color={isEdit ? "success" : "primary"}
                        startIcon={isEdit ? <UpdateIcon /> : <SaveIcon />}
                    >
                        {isEdit ? "Update" : "Save"}
                    </Button>
                </Grid>
            </Grid>
        </>
    )
}

export default memo(StatusSubmitGrid);
